<template>
    <div>
        <div class="container" v-if="!showGame">
            <!-- <div class="index-banner" >
                <p>We are a caring company that</p>
            </div> -->
            <swiper @show='show'></swiper>
            <div class="index-main01">
                <div class="index-main-all width">
                    <p class="p1">为养宠用户提供一站式专业服务的科技公司</p>
                    <p class="p2 font-medium">COMPANY  PROFILE</p>
                    <p class="p3">上海索洛信息技术有限公司成立于2015年，专注为养宠用户提供专业服务。我们在养宠相关领域拥有完善的产品与解决方案，坚持安全可信赖的品质标准，并与生态伙伴开放合作，持续推动行业进步，为用户创造更丰富的养宠价值。</p>
                    <div class="index-main-button">
                            <router-link to="/intro"><button class="font-medium" >READ MORE</button></router-link>
                            <!-- <router-link :to="{name:'intro'}"><button>READ MORE</button></router-link> -->
                        </div>
                    <div class="index-main-sidebar">
                        <span class="spanXolo font-medium">www.xolo.vip</span>
                        <span class="span01 font-medium">01</span>
                    </div>
                </div>
            </div>
            <div class="index-main02">
                    <div class="index-main-all">
                        <div class="width-center">
                            <p class="p1">持续为用户带来专业、多元的服务体验</p>
                            <p class="p3 font-medium">Professional, diverse services — always here for our users.</p>
                            <div class="index-main-sidebar">
                                <span class="spanXolo font-medium">www.xolo.vip</span>
                                <span class="span01 font-medium">02</span>
                            </div>
                        </div>
                </div>
                <div class="index-main-all02">
                    <div class="width-center">
                        <div class="index-main-images">
                            <ul>
                                <li v-for="(item,index) in items" :key="index">
                                    <img :src="item.img" />
                                </li>
                            </ul>
                        </div>
                        <div class="index-main-list">
                            <ul>
                                <li v-for="(list,index) in lists" :key="index">
                                    <p class="p1" v-html="list.title"></p>
                                    <p class="p2">{{list.content}}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="index-main-button">
                            <router-link to="/business"><button class="font-medium">READ MORE</button></router-link>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="index-main03">
                <div class="index-main-all01">
                    <div class="width-center">
                        <div class="index-main-content">
                            <p class="p1">善待动物，让爱不再流浪<br/>这是索洛倡导的核心价值观</p>
                            <span class="index-striping"></span>
                            <p class="p3 font-medium">03</p>
                        </div>
                        <div class="index-main-content02">
                            <p class="p1 font-medium">PUBLIC WELFARE</p>
                            <span class="index-striping"></span>
                            <i><img :src="imgDog" alt=""/></i>
                        </div>
                    </div>
                </div>
                <div class="index-main-all02">
                    <div class="width-center">
                        <div class="index-main-content3">
                            <p class="p1">领养代替购买</p>
                            <p class="p2">我们始终倡导并奉行善待动物的核心价值观，在拓展业务的同时，积极履行社会责任。</p>
                            <p class="p3">自成立以来，公司持续回馈社会，投身动物救助事业。我们在全国范围内开展公益项目，支持领养行动，呼吁“领养代替购买”，希望以企业之力为社会带来更多温暖与美好。</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="index-main04">
                <div class="index-main-all">
                    <div class="index-main-content">
                        <p class="p1">合作品牌</p>
                        <p class="p2 font-medium">COOPERATION BRABD</p>
                    </div>
                    <div class="index-main-imageList">
                        <img :src="indexlogo" alt=""/>
                        <!-- <ul>
                            <li v-for="(td,index) in tds" :key="index">
                                <img v-lazy="td.img" />
                            </li>
                        </ul> -->
                    </div>
                        <div class="index-main-sidebar">
                            <span class="spanXolo font-medium">www.xolo.vip</span>
                            <span class="span01 font-medium">04</span>
                        </div>
                </div>
            </div>
        </div>
        <activity v-else ></activity>
        </div>
</template>

<script>
import swiper from '../components/swiper'
import activity from '../pages/activity'
export default {
  name: 'index',
  data(){
    return{
        showGame: false,
        items:[
            {
                img:require('../assets/index/pic_1.png')
            },
            {
                img:require('../assets/index/pic_2.jpg')
            },
            {
                img:require('../assets/index/pic_3.png')
            },
        ],
        lists:[
            {
                title:'MollyBox魔力猫盒-订阅制商城',
                content:'一站式养猫服务，我们整合每月养猫所需的全品类用品，免去断粮、选品等繁琐事务，让铲屎官享受简单、省心、轻松的养猫体验。'
            },
             {
                title:'六脚兽-会员制商城',
                content:'为会员提供专属服务与优惠价格，致力于打造高性价比的购物体验。通过优选商品、清晰分类和简洁的购物流程，降低选购门槛，让会员享受省心、便捷的购物过程。'
            },
             {
                title:'自媒体平台',
                content:'紧跟行业趋势，深耕萌宠自媒体领域，以有深度、有温度的内容，结合扎实的创作能力与专业知识，为读者带来兼具实用性、功能性与情感共鸣的阅读体验。'
            }
        ],
        imgDog:require('../assets/index/pic_4.png'),
        indexlogo:require('../assets/index/logo/index_logo2x.png'),
    }
  },
  components: {
      swiper,
      activity
  },
  methods:{
      show(){
        //   this.showGame = true
      }
  },
  props: {
  }
}
</script>

<style scoped lang="less">
    //共用
    .button{
        background-color: #ffffff;
        border: solid 2px #333333;
        font-size: 16px;
        width: 158px;
        height: 54px;
        font-weight: 600;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
        cursor: pointer;
    }
    .width{width: 1100px;margin: 0 auto;}
    .PingFangSC-Medium{font-family: "HKGrotesk-Medium"};  
    .PingFangSC-Light{font-family: "HKGrotesk-Light"};
    .PingFangSC-Bold{font-family: "HKGrotesk-Bold"}
    .PingFangSC-Regular{font-family: "HKGrotesk-Regular"}
    .PingFangSC-SemiBold{font-family: "HKGrotesk-SemiBold"}
    .indexMainSidebar{ 
        position:absolute;
        left: -46+-90px;
        top: 134+90px;
        line-height: 20px;
        transform: rotate(90deg);
        .spanXolo{
            display: inline-block;
            font-size: 10px;
            letter-spacing: 2px;
            color: #999999;
            float: left;
            padding-right:58px 
        }
        .span01{
            transform: rotate(-90deg);
            float: left;
                display: inline-block;
            font-size: 18px;
            letter-spacing: 0px;
            color: #333333;
        }
        }
   
   //引用
    .index-banner{
        width: 100%;
        height: 600px;//原792
        background: url('../assets/index/banner.jpg') center center no-repeat;
        background-size:cover ;
        // min-height: 100vh;
        text-align: center;
        p{ 
            line-height: 694px;
            font-size: 66px;
            // line-height: 72px;
            letter-spacing: 9px;
            color: #ffffff;
            padding-top: 98px;
        }
    }
    .index-main01{
        width: 100%;
        height: 550px;
        background: #fff;
        text-align: center;
        .index-main-all{
            position: relative;
            .p1{
               font-size: 32px;letter-spacing: 5px;color: #333333;padding: 142px 0 22px;line-height: 32px;font-weight: 600;
            }
            .p2{
                font-size: 16px;
                letter-spacing: 4px;
                color: #666666;
                padding-bottom: 52px;
            }
            .p3{
                font-size: 16px;
                letter-spacing: 2px;
                color: #333333;
                line-height: 29px;
                text-align: justify;
                text-align-last:center; 
            }
            // .p3:after {
            //     content: " ";
            //     display: inline-block;
            //     width: 100%;
            // }
            .p4{
                font-size: 16px;
                letter-spacing: 2px;
                color: #333333;
                line-height: 29px;
                text-align: center;
            }
            .index-main-button{
                padding-top: 52px;
                button{
                    .button;
                }
            }
            .index-main-sidebar{
                .indexMainSidebar;
            }
        }
        
    }
    .index-main02{
        width: 100%;
        height: 1182px;
        .index-main-all{
            width: 100%;
            height: 569px;
            background: #f5f2f0;
            .p1{
                font-size: 32px;letter-spacing: 5px;color: #333333;padding: 175px 0 22px;text-align: center;line-height: 32px;font-weight: 600;
            }
            .p3{
                width:900px;font-size: 16px;letter-spacing: 2px;color: #333333;text-align: center;margin: 0 auto;
            }
            .width-center{
                .width;
                position: relative;
                .index-main-sidebar{
                    position:absolute;
                    right: -33+-90px;
                    top: 260+90px;
                    line-height: 20px;
                    transform: rotate(90deg);
                    .spanXolo{
                        display: inline-block;
                        font-size: 10px;
                        letter-spacing: 2px;
                        color: #999999;
                        float: left;
                        padding-right:58px 
                    }
                    .span01{
                        transform: rotate(-90deg);
                        float: left;
                        display: inline-block;
                        font-size: 18px;
                        letter-spacing: 0px;
                        color: #333333;
                    }
                }
            }
        }
        .index-main-all02{
            .width-center{
                .width;
                .index-main-images{
                    ul{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        li{
                            margin-top:-199px; 
                            height: 322px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;
                            img{
                                display: block;
                            }
                        }
                        li:nth-of-type(1){
                            width: 310px;
                        }
                        li:nth-of-type(2){
                            width: 479px;
                        }
                        li:nth-of-type(3){
                            width: 312px;
                        }
                    }
                   
                    
                }
                .index-main-list{
                    width: 100%;
                    ul{
                        overflow: hidden;
                        li{
                            float: left;
                            width: 327px;
                            text-align: justify;
                            .p1{
                                padding: 87px 0 35px;font-size: 22px;color: #333333;font-weight: 600;
                            }
                            .p2{
                                font-size: 16px;letter-spacing: 0px;color: #666666;line-height: 29px
                            }
                        }
                        li:nth-of-type(2){
                            padding: 0 58px 0 61px;
                        }
                    }
                }
                .index-main-button{
                    text-align: center;
                    padding:85px 0;
                }
            }
            button{
                .button;
            }
        }
         
    }
    .index-main03{
        width: 100%;
        height: 1050px;
        .index-main-all01{
            height: 572px;
            background: #f5f2f0;
            .width-center{
                .width;
                .index-main-content{
                    float: left;width:651px;
                    .p1{
                        width: 651px;
                        font-size: 32px;
                        line-height: 53px;
                        letter-spacing: 5px;
                        color: #333333;
                        padding: 128px 0 71px;
                        font-weight: 600;
                    }
                    .index-striping{
                        display: block;
                        width: 37px;
                        height: 3px;
                        background-color: #c87b75;
                    }
                    .p3{
                        font-size: 18px;
                        letter-spacing: 0px;
                        color: #333333;
                        padding-top: 220px;
                    }
                }
                .index-main-content02{
                    float: left;
                    padding-top:154px; 
                    position: relative;
                    width: 1100-651px;
                    .p1{
                        font-size: 16px;
                        letter-spacing: 4px;
                        color: #666666;
                        padding-left: 204px;
                    }
                    .index-striping{
                        position: absolute;
                        right: -25px;
                        top: 150px;
                        width: 5px;
                        height: 71px;
                        background-color: #c87b75;
                        opacity: 0.42;
                    }
                    i{
                        width: 614px;
                        height: 664px;
                        position: absolute;
                        right: 0;
                        top: 308px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                    }
                    img{
                        display: block;
                    }
                }
            }
        }
        .index-main-all02{
           height:1050-572px;
           .width-center{
               .width;
               .index-main-content3{
                   width: 412px;
                   .p1{
                        font-size: 22px;
                        letter-spacing: 0px;
                        color: #333333;
                        padding: 77px 0 37px;
                        font-weight: 600;
                   }
                   .p2,.p3{
                        font-size: 16px;
                        letter-spacing: 0px;
                        color: #666666;
                        line-height: 29px;
                   }
                   .p2{
                       padding-bottom: 28px
                   }
               }
           }
        }
    }
    .index-main04{
        // height: 621px;
        .index-main-all{
            .width;
            position: relative;
            text-align: center;
            .p1{
                font-size: 32px;letter-spacing: 5px;color: #333333;padding: 64px 0 18px;font-weight: 600;
            }
            .p2{
                font-size: 16px;
                letter-spacing: 4px;
                color: #666666;
                padding-bottom: 60px;
            }
            .index-main-imageList{
                width: 1100px;
                margin-bottom: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                min-height: 484px;
                img{
                    display: block
                }
                ul{
                    overflow: hidden;
                    border-top:1px solid #f0f0f0;
                    border-left: 1px solid #f0f0f0; 
                    li{float: left;
                        border-right:1px solid #f0f0f0;
                        border-bottom: 1px solid #f0f0f0; 
                        width: 182px;
                        height: 102px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        img{
                            display: block
                        }
                    }
                    .last-image{
                        width: 182px;
                        height: 102px;
                        display: flex;
                        align-items: center;
                        // flex-direction: column;
                        cursor: pointer;
                        justify-content: center;
                        img{
                            width: 42px;
                            height: 28px;
                            padding-right:8px; 
                        }
                        span{
                            font-size: 24px;
                            letter-spacing: 0px;
                            color: #333333;
                        }
                    }
                }
            }
            .index-main-sidebar{
                .indexMainSidebar
            }
        }
    }
    @media  screen and(max-device-width:980px) {
        
    }
</style>
